import { Component } from "@angular/core";
import { AddAddendumUpcomingComponent } from "../add-addendum-upcoming/add-addendum-upcoming.component";

@Component({
  selector: "app-add-addendum",
  templateUrl: "../add-addendum-upcoming/add-addendum-upcoming.component.html",
  styleUrls: ["../add-addendum-upcoming/add-addendum-upcoming.component.scss"],
})
export class AddAddendumComponent extends AddAddendumUpcomingComponent {}
